import { queryClient } from '@core/query'
import { LikeQueryKey } from './queryKeys'

export type TLikedSnapshot = string[] | undefined

export const snapshotLikedAudioIds = (): TLikedSnapshot =>
    queryClient.getQueryData<string[]>(LikeQueryKey.likedAudioIds())

export const applyLikedAudioId = (audioId: string, isLiked: boolean) => {
    queryClient.setQueryData<string[]>(LikeQueryKey.likedAudioIds(), previous => {
        if (!previous) {
            return previous
        }

        if (isLiked) {
            return previous.includes(audioId) ? previous : [...previous, audioId]
        }

        return previous.filter(id => id !== audioId)
    })
}

export const restoreLikedAudioIds = (snapshot: TLikedSnapshot) => {
    // setQueryData ignores `undefined` (react-query bails), so a list that was uncached at mutate
    // time can't be rolled back by writing undefined — drop the optimistic entry instead.
    if (snapshot === undefined) {
        queryClient.removeQueries({ queryKey: LikeQueryKey.likedAudioIds(), exact: true })

        return
    }

    queryClient.setQueryData(LikeQueryKey.likedAudioIds(), snapshot)
}
